import { render } from "./Pay.vue?vue&type=template&id=22fd97c8&scoped=true"
import script from "./Pay.vue?vue&type=script&lang=js"
export * from "./Pay.vue?vue&type=script&lang=js"

import "./Pay.vue?vue&type=style&index=0&id=22fd97c8&scoped=true&lang=css"
import "./Pay.vue?vue&type=style&index=1&id=22fd97c8&media=print&lang=css"
script.render = render
script.__scopeId = "data-v-22fd97c8"

export default script